import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { Base } from '../base'

// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.fields.read_only.outbound_call')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.fields.read_only.inbound_call')
export const ReadonlyPhoneCallInline = ({ kind, fieldNamePrefix }) => {
  const phoneNumberFieldName = `${fieldNamePrefix}.phoneNumber`

  const [{ value }] = useFormField({ name: phoneNumberFieldName })
  return (
    <Base>
      <BodyText>{I18n.t(`publisher.event_type_editor.sections.event_details.location.fields.read_only.${kind}`)}</BodyText>
      <BodyText>{value}</BodyText>
    </Base>
  )
}
